/* "How device connection works" explainer — why biometric devices work with a web app. */
import { Icon } from "../../../ui";
import { useI18n } from "../../../i18n";

function Box({ icon, title, sub }: { icon: string; title: string; sub: string }) {
  return <div className="flow-box"><Icon name={icon} /><b>{title}</b><span>{sub}</span></div>;
}
function Arrow({ label }: { label: string }) {
  return <div className="flow-link"><Icon name="chevron-right" className="flow-arrow" /><span>{label}</span></div>;
}

export function HowItWorks({ open, testId = "how-it-works" }: { open?: boolean; testId?: string }) {
  const { L } = useI18n();
  return (
    <section className="card" data-testid={testId}>
      <details open={open} className="card-b accordion" style={{ padding: 0 }}>
        <summary style={{ padding: "16px 20px" }}>
          <span className="row" style={{ display: "inline-flex", gap: 8 }}><Icon name="info" className="s" />{L("How device connection works", "كيف يتم ربط الأجهزة")}</span>
        </summary>
        <div className="flow-wrap" style={{ padding: "0 20px 20px" }}>
          <p className="sm" style={{ margin: 0 }}>
            {L("Your devices talk directly to StartHR's secure cloud — not to your browser. The browser only shows the attendance StartHR has collected.",
              "تتصل أجهزتك مباشرة بسحابة ستارت HR الآمنة — وليس بمتصفحك. المتصفح يعرض فقط الحضور الذي جمعه ستارت HR.")}
          </p>
          <div>
            <div className="flow-cap"><Icon name="wifi" className="s" />{L("Cloud-ready devices (most ZKTeco, Hikvision, Suprema)", "الأجهزة الجاهزة للسحابة (معظم ZKTeco وHikvision وSuprema)")}</div>
            <div className="flow" data-testid="flow-cloud">
              <Box icon="fingerprint" title={L("Device", "الجهاز")} sub={L("Face / fingerprint / card", "وجه / بصمة / بطاقة")} />
              <Arrow label={L("internet · HTTPS", "الإنترنت · HTTPS")} />
              <Box icon="server" title={L("StartHR cloud", "سحابة ستارت HR")} sub={L("Collects & cleans punches", "يجمع البصمات وينقّحها")} />
              <Arrow label={L("automatic", "تلقائيًا")} />
              <Box icon="wallet" title={L("Attendance & payroll", "الحضور والرواتب")} sub={L("Late, absence, overtime", "التأخير والغياب والإضافي")} />
            </div>
          </div>
          <div>
            <div className="flow-cap"><Icon name="wifi-off" className="s" />{L("Office-network (LAN) only devices", "الأجهزة على الشبكة المحلية فقط")}</div>
            <div className="flow" data-testid="flow-lan">
              <Box icon="fingerprint" title={L("Device", "الجهاز")} sub={L("Office network only", "الشبكة المحلية فقط")} />
              <Arrow label={L("office network", "شبكة المكتب")} />
              <Box icon="cpu" title={L("Office PC (StartHR Agent)", "حاسب المكتب (وكيل ستارت HR)")} sub={L("Reads devices locally", "يقرأ الأجهزة محليًا")} />
              <Arrow label={L("internet · HTTPS", "الإنترنت · HTTPS")} />
              <Box icon="server" title={L("StartHR cloud", "سحابة ستارت HR")} sub={L("Same pipeline", "نفس المعالجة")} />
            </div>
          </div>
          <div className="alert ok tint" role="note">
            <span className="ai"><Icon name="check" /></span>
            <div className="grow"><div className="alert-t">{L("No static IP, no port forwarding, no PC required for cloud-ready devices.", "لا حاجة لعنوان IP ثابت ولا لفتح منافذ ولا لحاسب للأجهزة الجاهزة للسحابة.")}</div>
              <div className="alert-d">{L("The device only makes outgoing HTTPS connections (port 443), like a phone browsing a website.", "يُجري الجهاز اتصالات صادرة فقط عبر HTTPS (المنفذ 443) تمامًا كجوال يتصفح موقعًا.")}</div></div>
          </div>
        </div>
      </details>
    </section>
  );
}
